import type { NoteEvent } from '../progression/index.js'
import { convertDuration } from './convert-duration.js'
import { isDottedEasyScoreDuration, undotted } from './duration.js'
import type { EasyScoreNoteString } from './simple-note.js'

export const noteEventString = (event: NoteEvent): EasyScoreNoteString => {
  const { octave = 4, note, duration, rest } = event

  /** A tie is not written here: VexFlow's EasyScore has no syntax for it, so the renderer draws it. */
  const token = convertDuration(duration)
  if (!rest) {
    return `${note}${octave}/${token}`
  }
  /** VexFlow reads a rest's dot after the type - `B4/h/r.`; `B4/h./r` does not parse as dotted. */
  return isDottedEasyScoreDuration(token) ? `${note}${octave}/${undotted(token)}/r.` : `${note}${octave}/${token}/r`
}
